export const text = {
  INTAKE_FORM: 'Intake form',
  VISIBLE_TO: 'Visible to',
  FOLLOW_UP_EMAILS: 'Follow up email',
  FOLLOW_UP_EMAILS_DESCRIPTION: 'Send rebooking reminders',
  MAT_MOUD_TITLE: 'MAT/MOUD',
  MAT_MOUD_DESCRIPTION: 'Patient must complete drug screening:',
} as const

export const visibilityVisitTypeValues = {
  all: 'All patients',
  deeplink: 'No patients (Deep linking)',
  new: 'New patients only',
  established: 'Established patients only',
  none: 'No patients (unpublished)',
} as const
